export default __webpack_public_path__ + "static/media/goldmagic.024ef49d.png";